import { Navigate } from 'react-router-dom';
import { useAuth } from '../modules/Authentication';

/**
 * Protected Route Component — UX ONLY
 * This frontend guard is convenience/UX and is NOT a security boundary.
 * Backend authorization (401/403 via StaffAuthGuard+RolesGuard) is authoritative.
 * Do not rely on user.role or this component for actual access control.
 */
function ProtectedRoute({ children, requiredRole = null }) {
    const { isAuthenticated, user, loading } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
            }}>
                <div>در حال بارگذاری...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Redirect to appropriate login page based on required role
        if (requiredRole === 'admin') {
            return <Navigate to="/admin/login" replace />;
        } else if (requiredRole === 'operator') {
            return <Navigate to="/operator/login" replace />;
        }
        return <Navigate to="/login" replace />;
    }

    // UX-only role check – backend remains authoritative
    if (requiredRole && user?.role !== requiredRole) {
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default ProtectedRoute;
